import { FC, useCallback, useEffect } from "react";
import CustomPopup from "../CustomPopup/CustomPopup";
import { Box, Button, Typography } from "@mui/material";
import noConnectionImage from "../../assets/images/no-connection.svg";
import { Colors } from "../../styles/constant";
import { triggerCleverTapEvent } from "../../utils/CleverTap";
import TriggerGTAEvent from "../../utils/GTA";
import { GTAScreenType, statusCode, SCREEN_TYPE } from "../../utils/constants";
import { useLazySaveUiExceptionQuery } from "../../features/Feature_GeneralAppElements/GeneralAppElements_Api";
import "./APIFailurePopup.scss";
import { API_STATUS_CODE } from "../../utils/ApiEndpoints";

interface Props {
  open: boolean;
  handleOpen: Function;
  customTitle?: string;
  customSubTitle?: string;
  customButtonLabel?: string;
  errorFromUI?: boolean;
  pageName?: string;
  errorMessage?: any;
  moduleName?: string;
}

const APIFailurePopup: FC<Props> = ({
  open,
  handleOpen,
  customTitle = "Technical Failure",
  customSubTitle = `Apologies! We are encountering technical challenges in fulfilling
            your request. Please try again after sometime.`,
  customButtonLabel = `Got it`,
  errorFromUI = false,
  pageName,
  errorMessage,
  moduleName,
}) => {
  const [saveUIExceptionApi] = useLazySaveUiExceptionQuery();

  const saveUIExceptionApiFun = async () => {
    const payload = {
      module: moduleName ? moduleName : "",
      pageName: pageName ? pageName : "",
      type: "UI",
      httpStatusCode: statusCode,
      httpErrorCode: "error",
      httpErrorMessage: "errorMessage",
      uiDisplayTitle: "Technical Error",
      uiDisplayMessage: "",
      errorStack: errorMessage?.stk || "",
      errorStackMessage: errorMessage?.msg || "",
    };

    await saveUIExceptionApi(payload).then((res) => {
      if (res.isError || res.data?.code !== API_STATUS_CODE.SUCCESS) {
        console.error("Error sending exception details", res?.error);
      }
    });
  };

  useEffect(() => {
    if (errorFromUI && errorMessage) {
      saveUIExceptionApiFun();
    }
  }, [errorMessage]);

  const handleClick = useCallback(() => {
    triggerCleverTapEvent("li_serv_error_failure_cta_click", {
      ScreenType: SCREEN_TYPE.LIScreenType,
      isPrevPageNameRequired: true,
      ScreenName: "Life Insurance Servicing API Failure Error Screen",
      DrawerTitle: "techincal_failure",
      ctaText: "got_it",
    });

    TriggerGTAEvent("li_serv_error_failure_cta_click", {
      screen_type: GTAScreenType.LIScreenType,
      screen_name: "life_insurance_servicing_api_failure_error_screen",
      drawer_title: "techincal_failure",
      CTA_text: "got_it",
    });
    handleOpen(false);
  }, []);

  return (
    <CustomPopup
      open={open}
      handleOpen={handleOpen}
      className="api-failure-popup"
    >
      <Box padding="1.5rem 1rem">
        <Box display="flex" justifyContent="center">
          <img src={noConnectionImage} alt="no-connection" />
        </Box>
        <Box marginTop="1.5rem">
          <Typography textAlign="center" variant="h3">
            {customTitle}
          </Typography>
          <Typography
            marginTop="1rem"
            textAlign="center"
            variant="h5"
            paddingX="1.25rem"
            color={Colors.textGray}
          >
            {customSubTitle}
          </Typography>
        </Box>
        {
          <Button
            fullWidth
            variant="contained"
            sx={{ marginTop: "1rem" }}
            onClick={handleClick}
          >
            {customButtonLabel}
          </Button>
        }
      </Box>
    </CustomPopup>
  );
};

export default APIFailurePopup;
